module.exports = __webpack_public_path__ + "static/entrepreneur-3-b458b5e03f340479a5ee4af8371fa370.webp";